import { Check } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const POINTS = [
  "Built with construction business workflows in mind",
  "Product-led approach with real delivery experience",
  "Bespoke development capability where needed",
  "Clear, straightforward, specialist positioning",
];

export const WhyBlueShuck = () => {
  return (
    <section
      id="why-blue-shuck"
      data-testid="why-blueshuck-section"
      className="py-20 md:py-32 bg-slate-50 border-y border-slate-100"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <Reveal className="lg:col-span-5">
            <p className="text-xs font-semibold tracking-[0.2em] uppercase text-brand-blue">
              Why Blue Shuck
            </p>
            <h2 className="mt-4 font-heading font-700 text-3xl sm:text-4xl lg:text-5xl tracking-tight text-brand-navy">
              Focused software with practical business value
            </h2>
          </Reveal>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {POINTS.map((point, i) => (
                <Reveal key={point} delay={i * 0.08}>
                  <div
                    data-testid={`why-point-${i}`}
                    className="h-full flex items-start gap-4 rounded-xl bg-white border border-slate-200 p-6 hover:shadow-md hover:-translate-y-1 transition-all duration-300"
                  >
                    <span className="mt-0.5 inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-brand-blue/10 text-brand-blue">
                      <Check className="h-5 w-5" strokeWidth={2.5} />
                    </span>
                    <p className="text-base font-medium leading-relaxed text-slate-700">
                      {point}
                    </p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
